<template>
  <profile-edit-section-card
    v-if="localState"
    title="Education"
    breadcrumb-label="Profile"
    :has-unsaved-changes="hasUnsavedChanges"
    @breadcrumb-click="cancelEdit"
    @save="handleSave"
    @cancel="cancelEdit"
  >
    <fieldset>
      <Dropdown
        id="levelOfEducation"
        v-model="localState.education.levelOfEducation"
        class="mb-8"
        :options="educationLevelOptions"
        label-name="Level of education"
      />
      <TextField id="major" v-model="localState.education.major" class="mb-8" label-name="Major" />
      <TextField id="schoolName" v-model="localState.education.schoolName" class="mb-8" label-name="School Name" />
      <TextField
        v-if="!localState.education.levelOfEducation?.toLowerCase().startsWith('some')"
        id="yearGraduated"
        v-model="localState.education.yearGraduated"
        class="mb-8"
        label-name="Year Graduated"
        type="number"
      />
      <Checkbox
        id="currentlyAttending"
        v-model="localState.education.currentlyAttending"
        label-name="Currently Attending"
        class="-mb-16"
      />
    </fieldset>
  </profile-edit-section-card>
</template>

<script lang="ts">
import ProfileEditSectionCard from '../../components/ProfileEditSectionCard.vue';
import TextField from '@/components/textfield/TextField.vue';
import Dropdown from '@/components/dropdown/Dropdown.vue';
import Checkbox from '@/components/checkbox/Checkbox.vue';

import { educationLevelOptions } from '../../__types__/CareTypeFormOptions.js';
import profileEditMixin from '../../mixins/profileEditMixin';

export default {
  name: 'EducationForm',
  components: {
    ProfileEditSectionCard,
    TextField,
    Dropdown,
    Checkbox,
  },
  mixins: [profileEditMixin],
  data() {
    return {
      localState: null,
      originalState: null,
      hasInvalidInput: false,
    };
  },
  computed: {
    educationLevelOptions: () => educationLevelOptions(),
    hasUnsavedChanges(): boolean {
      if (!this.localState || !this.originalState) return false;
      return JSON.stringify(this.localState) !== JSON.stringify(this.originalState);
    },
  },
  watch: {
    $route() {
      this.initializeFormState();
    },
    formState: {
      handler(newState) {
        if (newState) {
          this.initializeFormState();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.initializeFormState();
  },
  methods: {
    initializeFormState() {
      const state = this.formState as Record<string, any> | null;
      if (!state) return;
      this.localState = {
        education: {
          levelOfEducation: state.education?.levelOfEducation?.toUpperCase() || null,
          major: state.education.major || '',
          schoolName: state.education.schoolName || '',
          yearGraduated: state.education.yearGraduated || null,
          currentlyAttending: state.education.currentlyAttending || false,
        },
      };
      this.originalState = JSON.parse(JSON.stringify(this.localState));
    },
    async handleSave() {
      if (!this.localState) return;

      if (this.hasUnsavedChanges) {
        await this.saveSection({
          education: {
            levelOfEducation: this.localState.education.levelOfEducation,
            major: this.localState.education.major,
            schoolName: this.localState.education.schoolName,
            currentlyAttending: this.localState.education.currentlyAttending,
            yearGraduated: this.localState.education.yearGraduated?.toString().length
              ? this.localState.education.yearGraduated
              : null,
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.form-group {
  margin-bottom: 1rem;
}
</style>
